import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Please check for any misspellings and try again. If you still need help, please contact us at ")
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_greeting = _resolveComponent("page-greeting")!
  const _component_no_students_banner_message = _resolveComponent("no-students-banner-message")!
  const _component_banner_message = _resolveComponent("banner-message")!
  const _component_loading_indicator = _resolveComponent("loading-indicator")!
  const _component_parent_home = _resolveComponent("parent-home")!
  const _component_student_home = _resolveComponent("student-home")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.greetingMessage)
        ? (_openBlock(), _createBlock(_component_page_greeting, {
            key: 0,
            title: _ctx.greetingTitle,
            message: _ctx.greetingMessage
          }, null, 8, ["title", "message"]))
        : _createCommentVNode("", true),
      (!_ctx.hasStudents && _ctx.isUserLoaded && _ctx.isAuthorized)
        ? (_openBlock(), _createBlock(_component_no_students_banner_message, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.showBanner)
        ? (_openBlock(), _createBlock(_component_banner_message, {
            key: 2,
            header: _ctx.banner?.header ?? '',
            message: _ctx.banner?.message ?? ''
          }, null, 8, ["header", "message"]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_loading_indicator, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.isParent && _ctx.isUserLoaded)
        ? (_openBlock(), _createBlock(_component_parent_home, { key: 4 }))
        : (_ctx.isStudent && _ctx.isUserLoaded)
          ? (_openBlock(), _createBlock(_component_student_home, { key: 5 }))
          : _createCommentVNode("", true),
      (_ctx.isUserLoaded && !_ctx.isAuthorized)
        ? (_openBlock(), _createBlock(_component_banner_message, {
            key: 6,
            type: "warning",
            header: "Ooops! We can't find an account for the email address you used!"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _hoisted_3,
                _createElementVNode("a", {
                  href: `mailto:${_ctx.helpEmail}`
                }, _toDisplayString(_ctx.helpEmail), 9, _hoisted_4),
                _hoisted_5
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}